import type { Template } from "@/types";

export const PO_06_H3_V3: Template[] = [
    {
        id: "po-06-h3v3-01",
        name: "PO 01 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_01.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 47, y: 174, width: 244, height: 154, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 336, width: 244, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 299, y: 174, width: 332, height: 477, rotation: 0, imageRotation: 0 },
            { id: "4", x: 47, y: 498, width: 244, height: 153, rotation: 0, imageRotation: 0 },
            { id: "5", x: 670, y: 206, width: 290, height: 415, rotation: 0, imageRotation: 0 },
            { id: "6", x: 968, y: 206, width: 289, height: 415, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-02",
        name: "PO 02 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 146, width: 369, height: 535, rotation: 0, imageRotation: 0 },
            { id: "2", x: 422, y: 146, width: 185, height: 264, rotation: 0, imageRotation: 0 },
            { id: "3", x: 422, y: 418, width: 185, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 694, y: 146, width: 560, height: 355, rotation: 0, imageRotation: 0 },       
            { id: "5", x: 694, y: 509, width: 276, height: 172, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 509, width: 276, height: 172, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-03",
        name: "PO 03 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 44, y: 146, width: 560, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 509, width: 276, height: 172, rotation: 0, imageRotation: 0 },
            { id: "3", x: 328, y: 509, width: 276, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 146, width: 369, height: 535, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 146, width: 185, height: 264, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 418, width: 185, height: 263, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-04",
        name: "PO 04 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 47, y: 134, width: 585, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 514, width: 289, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 344, y: 514, width: 288, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 180, width: 319, height: 468, rotation: 0, imageRotation: 0 },          
            { id: "5", x: 1046, y: 180, width: 162, height: 230, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1046, y: 418, width: 162, height: 230, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-05",
        name: "PO 05 - H3V3",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_05.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 55, y: 78, width: 338, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 304, width: 338, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 55, y: 530, width: 338, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 401, y: 78, width: 470, height: 669, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1011, y: 78, width: 229, height: 331, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1011, y: 417, width: 229, height: 330, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-06",
        name: "PO 06 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_06.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 65, y: 154, width: 416, height: 256, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 418, width: 416, height: 255, rotation: 0, imageRotation: 0 },
            { id: "3", x: 489, y: 154, width: 122, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 489, y: 330, width: 122, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 489, y: 506, width: 122, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 701, y: 240, width: 546, height: 347, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-07",
        name: "PO 07 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_07.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 65, y: 154, width: 270, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 154, width: 270, height: 395, rotation: 0, imageRotation: 0 },
            { id: "3", x: 65, y: 557, width: 178, height: 115, rotation: 0, imageRotation: 0 },
            { id: "4", x: 251, y: 557, width: 177, height: 115, rotation: 0, imageRotation: 0 },
            { id: "5", x: 436, y: 557, width: 177, height: 115, rotation: 0, imageRotation: 0 },
            { id: "6", x: 792, y: 154, width: 364, height: 519, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h3v3-08",
        name: "PO 08 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 44, y: 186, width: 330, height: 454, rotation: 0, imageRotation: 0 },
            { id: "2", x: 382, y: 186, width: 330, height: 454, rotation: 0, imageRotation: 0 },
            { id: "3", x: 720, y: 186, width: 329, height: 454, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1057, y: 186, width: 198, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1057, y: 340, width: 198, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1057, y: 494, width: 198, height: 146, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-09",
        name: "PO 09 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 49, y: 237, width: 120, height: 172, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 417, width: 270, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 177, y: 237, width: 270, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 327, y: 417, width: 120, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 455, y: 237, width: 549, height: 353, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1012, y: 237, width: 238, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-10",
        name: "PO 10 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_10.png",
        size: [1298, 827],
        style: {},
        slots: [       
            { id: "1", x: 0, y: 225, width: 133, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 418, width: 133, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 141, y: 225, width: 589, height: 377, rotation: 0, imageRotation: 0 },
            { id: "4", x: 738, y: 225, width: 276, height: 377, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1022, y: 225, width: 276, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1022, y: 418, width: 276, height: 184, rotation: 0, imageRotation: 0 }
        ],
    }
];